import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableTokenLookup = loadable(() => import('./TokenLookup'), {
  fallback: <LoadingScreen />,
});

export default LoadableTokenLookup;
